import { useSelector } from 'react-redux';
import "./PoweredByLogo.scss";

export const PoweredByLogo: React.FC = () => {
  const poweredByI2ILogo = useSelector(
    (state: any) => state?.configuration?.poweredByI2ILogo,
  );

  return (
    <div className="powered-by-logo">
      <img
        src={`${decodeURIComponent(poweredByI2ILogo)}`}
        alt="logo"
        className="d-inline-block"
      />
    </div>
  );
};
